/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Dialog } from "../Dialog";
import { InputDialogComponent } from "./InputDialogComponent";
import { IFieldConfig } from "../../ui/hooks/useFieldGroup";
import { ACTION_BUTTON_STYLE } from "../../ui/components/ActionButton";

export interface InputDialog_Params {
	defaultValue?: string;
	validators?: IFieldConfig<string>["validators"];
	title?: string;
	description?: string;
	confirmLabel?: string;
	confirmStyle?: ACTION_BUTTON_STYLE;
	cancelLabel?: string;
	cancelStyle?: ACTION_BUTTON_STYLE;
}

export interface InputDialog_Result {
	value: string;
}

export class InputDialog extends Dialog<InputDialog_Params, InputDialog_Result> {
	public getComponent(): typeof InputDialogComponent {
		return InputDialogComponent;
	}
}
